import styled from "styled-components";

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;

  padding-top: 25px;
  padding-bottom: 25px;

  > div {
    display: flex;
  }
`;

const LeftChild = styled.div`
  width: 25%;
  justify-content: start;
  cursor:pointer;
`;

const HeadText = styled.div`
  width: 50%;
  font-weight: 700;
  font-size: 20px;
  justify-content: center;
`;

const RightChild = styled.div`
  width: 25%;
  justify-content: end;
  cursor:pointer;
`;

const Header = ({ leftChild, headText, rightChild, onClickLeftChild, onClickRightChild }) => {
  return (
    <HeaderContainer>
      <LeftChild onClick={onClickLeftChild}>{leftChild}</LeftChild>
      <HeadText>{headText}</HeadText>
      <RightChild onClick={onClickRightChild}>{rightChild}</RightChild>
    </HeaderContainer>
  );
};

export default Header;
